import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Payroll } from '@app/models/payroll/payroll.model';
import { AuthService } from '@app/services';
import { ShowView } from '@common/views';
import { EmployeeHourTable } from '@payroll/services';

@Component({
    templateUrl: './payroll-hours.template.html',
})
export class PayrollHoursView extends ShowView implements OnInit {
    payroll!: Payroll;
    table!: EmployeeHourTable;

    constructor(
        private auth: AuthService,
        private route: ActivatedRoute
    ) {
        super();
        this.payroll = this.route.snapshot.data.models.get('payroll');
    }

    async ngOnInit(): Promise<void> {
        this.table = new EmployeeHourTable(this.auth, false, this.payroll);
    }

    onSave(): void {}
    onCancel(): void {}
    onDelete(): void {}
}
